<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>
          
        <div class="card-header">
          <div class="card-title">
              <h5 style="text-align: start">{{ title }}</h5>
          </div> 
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-if="!saleInvoices?.length" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
              <div class="text-gray-700 fs-4 fw-bold">{{ $t('statistics.sale_invoices') }}</div>
            </div>
            <div v-if="saleInvoices?.length" class="p-5">
              <h5 style="margin-bottom: 20px; text-align: start">{{ $t('statistics.sale_invoices') }} ({{ defaultCurrency?.symbol }})</h5>
              <canvas id="kt_chartjs_invoices" class="mh-200px"></canvas>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import {  onMounted, ref} from 'vue';
import { useStore } from 'vuex';
import { computed } from 'vue';
import Loader from '@/components/Loader.vue';
import { watch } from 'vue';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    
})

const saleInvoices = ref([])
const chartInvoiceRef = ref(null)

const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  if(isSafe(query.value.start_date) && isSafe(query.value.end_date)){
     Promise.all([
       props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date}).then((res) => {
          saleInvoices.value = res?.data?.invoiceTurnover || res?.response?.data;


        }),  
    ]).then(() => {
      chartInvoices()
    }) 
  }
    
}

function chartInvoices(){
  let ctx = document.getElementById('kt_chartjs_invoices');

  if(ctx){
    if(Chart.getChart("kt_chartjs_invoices")) {
      Chart.getChart("kt_chartjs_invoices")?.destroy()
    }
    let context = ctx.getContext('2d');

    let fontFamily = KTUtil.getCssVariableValue('--bs-font-sans-serif');
    let labels = []
    let dataValue = [];
    let dataCount = [];
    let backgroundColor = [];

    saleInvoices.value.forEach(invoice => {
      if(invoice.amount){
        if(invoice.name == 'VALIDATED'){
          labels.push(i18n.global.t('statistics.invoice_not_paid'))
          backgroundColor.push('rgba(240, 120, 23, 1)')
        }
        if(invoice.name == 'PAID'){
          labels.push(i18n.global.t('statistics.invoice_paid'))
          backgroundColor.push('rgba(54, 162, 235, 1)')
        }
        if(invoice.name == 'SEND'){
          labels.push(i18n.global.t('statistics.invoice_send'))
          backgroundColor.push('rgba(243, 220, 31, 1)')
        }
        dataValue.push(invoice.amount)
        dataCount.push(invoice.count)
      }
    })

    if(dataValue.length <= 0 || dataCount.length <= 0){
      saleInvoices.value = []
    }

    let data = {
      labels: labels,
      datasets: [{
        label: 'My First Dataset',
        data: dataValue,
        backgroundColor: backgroundColor,
        hoverOffset: 4
      }]
    };

    let config = {
      type: 'doughnut',
      data: data,
      options: {
        plugins: {
          legend: {
            display: true
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                return `${i18n.global.t('statistics.amount')}: ${$formatLocalAmount(context.parsed)} ${defaultCurrency.value?.symbol} (${dataCount[context.dataIndex]})`;
              }
            }
          }
        },
        responsive: true,
        elements: {
          arc: {
              borderWidth: 1 
          }
        },
        cutout: '80%'
      },
      defaults:{
        global: {
          defaultFont: fontFamily
        }
      }
    };

    if (!chartInvoiceRef.value) {
      chartInvoiceRef.value = new Chart(ctx, config);
    }else{
      chartInvoiceRef.value.destroy()
      chartInvoiceRef.value = new Chart(ctx, config);
    }
  }

}
  
onMounted(() => {
  if(props.start) query.value.start_date = props.start
  if(props.end) query.value.end_date = props.end
})

function isSafe(date){
  if(!date || date === undefined )
    return false

  return true
}
</script>